(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rms-header-vehicle-finder"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-rms-header-vehicle]');
    if (!root) return;
    const details = root.querySelector('details');
    const make = root.querySelector('[data-rms-header-vehicle-make]');
    const model = root.querySelector('[data-rms-header-vehicle-model]');
    const year = root.querySelector('[data-rms-header-vehicle-year]');
    const form = root.querySelector('[data-rms-header-vehicle-form]');
    const managedRows = [...root.querySelectorAll('[data-rms-header-vehicle-record]')]
      .map(element => ({ ...element.dataset }))
      .filter(row => row.make && row.model && Number(row.from) && Number(row.to));
    let rows = managedRows;
    let initialized = false;
    let initializePromise = null;

    const fill = (select, values, label, numeric = false) => {
      select.innerHTML = '';
      select.add(new Option(label, ''));
      [...new Set(values)]
        .sort(numeric ? (a, b) => Number(b) - Number(a) : (a, b) => a.localeCompare(b, 'sv'))
        .forEach(value => select.add(new Option(value, value)));
    };
    const destinationFor = row => {
      const fallback = 'vad-passar-min-bil-resultat';
      if (row.collection && row.collection !== fallback && row.collection !== 'all') return row.collection;
      const makeHandle = make.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const modelHandle = model.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const audiModels = ['a1','a2','a3','a4','a5','a6','a7','a8','q3','q5','q7','r8','tt'];
      const volvoModels = ['s40','s60','s80','s90','v40','v60','v70','v90','xc70','xc90'];
      if (makeHandle === 'audi' && audiModels.includes(modelHandle)) return `audi-${modelHandle}`;
      if (makeHandle === 'volvo' && volvoModels.includes(modelHandle)) return `passar-volvo-${modelHandle}`;
      if (makeHandle === 'bmw') {
        const series = modelHandle.match(/^([1-8])(?:-series|-serie)?$/)?.[1];
        if (series) return `bmw-${series}-serie`;
        if (['x1','x3','x5','x6'].includes(modelHandle)) return `bmw-${modelHandle}`;
        return 'allt-for-bmw';
      }
      return fallback;
    };
    const loadDatabase = () => {
      if (Array.isArray(window.RMSVehicleDatabase)) return Promise.resolve(window.RMSVehicleDatabase);
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = root.dataset.rmsVehicleDatabaseUrl;
        script.async = true;
        script.dataset.rmsVehicleDatabaseLoader = 'true';
        script.addEventListener('load', () => resolve(window.RMSVehicleDatabase || []), { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });
    };
    const initialize = () => {
      if (initializePromise) return initializePromise;
      const makeLabel = make.options[0]?.text || 'Bilmärke';
      const modelLabel = model.options[0]?.text || 'Modell';
      const yearLabel = year.options[0]?.text || 'Årsmodell';
      make.disabled = true;
      make.options[0].text = 'Laddar bilmärken…';
      initializePromise = loadDatabase()
        .then(database => {
          const databaseRows = database.map(row => ({
            make: row[0],
            model: row[1],
            from: String(row[2]),
            to: String(row[3]),
            key: [row[0], row[1], row[2], row[3]].join('-').toLowerCase()
              .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
              .replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''),
            collection: 'vad-passar-min-bil-resultat',
            source: 'external'
          }));
          rows = [...managedRows, ...databaseRows];
        })
        .catch(error => console.warn('RMS vehicle database could not be loaded.', error))
        .then(() => {
          fill(make, rows.map(row => row.make), makeLabel);
          make.disabled = false;
          let saved = null;
          try {
            saved = JSON.parse(localStorage.getItem('rms-selected-vehicle') || 'null');
          } catch (error) {}
          if (saved && rows.some(row => row.make === saved.make)) {
            make.value = saved.make;
            make.dispatchEvent(new Event('change'));
            model.value = saved.model;
            model.dispatchEvent(new Event('change'));
            year.value = saved.year;
          }
          initialized = true;
        });
      return initializePromise;
    };

    make.addEventListener('change', () => {
      if (!initialized) return;
      fill(model, rows.filter(row => row.make === make.value).map(row => row.model), 'Modell');
      fill(year, [], 'Årsmodell', true);
      model.disabled = !make.value;
      year.disabled = true;
    });
    model.addEventListener('change', () => {
      if (!initialized) return;
      const years = [];
      rows.filter(row => row.make === make.value && row.model === model.value).forEach(row => {
        for (let value = Number(row.to); value >= Number(row.from); value--) years.push(String(value));
      });
      fill(year, years, 'Årsmodell', true);
      year.disabled = !model.value;
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      await initialize();
      const matches = rows.filter(item =>
        item.make === make.value &&
        item.model === model.value &&
        Number(year.value) >= Number(item.from) &&
        Number(year.value) <= Number(item.to)
      );
      const managedMatches = matches.filter(item => item.source === 'registry');
      const row = matches.sort((a, b) => {
        const sourcePriority = { registry: 0, external: 1 };
        return (sourcePriority[a.source] ?? 2) - (sourcePriority[b.source] ?? 2) ||
          (Number(a.to) - Number(a.from)) - (Number(b.to) - Number(b.from));
      })[0];
      if (!row) return;
      const vehicle = {
        make: make.value,
        model: model.value,
        year: year.value,
        key: row.key,
        generation: row.generation || '',
        body: row.body || '',
        facelift: row.facelift || '',
        originalAudio: row.originalAudio || '',
        amplifier: row.amplifier || '',
        fitmentVerified: managedMatches.length === 1
      };
      localStorage.setItem('rms-selected-vehicle', JSON.stringify(vehicle));
      localStorage.setItem('rms-fitment-active', '1');
      document.dispatchEvent(new CustomEvent('rms:vehicle-selected', { detail: vehicle }));
      const params = new URLSearchParams({
        rms_make: make.value,
        rms_model: model.value,
        rms_year: year.value,
        rms_vehicle: row.key
      });
      location.href = `${window.Shopify?.routes?.root || '/'}collections/${destinationFor(row)}?${params}`;
    });
    details?.addEventListener('toggle', () => {
      if (details.open) initialize();
    });
    if (details?.open) initialize();
  })();
  (()=>{
    const root=document.querySelector('[data-rms-header-vehicle]');
    const status=root?.querySelector('[data-rms-header-vehicle-status]');
    const clear=root?.querySelector('[data-rms-header-vehicle-clear]');
    if(!root||!status||!clear)return;
    const defaultStatus='Välj bil och se rätt produkter';
    const showVehicle=vehicle=>{
      const selected=Boolean(vehicle?.make&&vehicle?.model&&vehicle?.year);
      root.classList.toggle('has-vehicle',selected);
      clear.hidden=!selected;
      status.textContent=selected?`Vald bil: ${vehicle.make} ${vehicle.model} ${vehicle.year}`:defaultStatus;
    };
    try{showVehicle(JSON.parse(localStorage.getItem('rms-selected-vehicle')||'null'))}catch(error){showVehicle(null)}
    document.addEventListener('rms:vehicle-selected',event=>showVehicle(event.detail));
    clear.addEventListener('click',()=>{
      localStorage.removeItem('rms-selected-vehicle');
      localStorage.setItem('rms-fitment-active','0');
      root.querySelector('details')?.removeAttribute('open');
      const make=root.querySelector('[data-rms-header-vehicle-make]');
      if(make){make.value='';make.dispatchEvent(new Event('change'))}
      showVehicle(null);
      document.dispatchEvent(new CustomEvent('rms:fitment-disabled'));
      const url=new URL(location.href);
      const hadFitment=['rms_make','rms_model','rms_year','rms_vehicle'].some(key=>url.searchParams.has(key));
      ['rms_make','rms_model','rms_year','rms_vehicle'].forEach(key=>url.searchParams.delete(key));
      if(hadFitment)location.href=url.toString();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
